# Profiles

Every source this build knows, plus any draft measured in this browser.

Each row carries when the source was last analysed here, how that run came out,
and whose policy governed it. "Not analysed here" means no run is in this
browser's cache — the cache is bounded, so it never means "no run ever".

## Overrides

A local override amends the committed policy for one source and requires a
reason, which the resolved policy hash records, so every artifact says it ran
under the override.

An override written against an older repo version is **stale** and is not
applied: a policy bump must not silently re-apply tweaks written against old
policy. Re-save it against the current version or remove it.
